import { useDataChange } from 'Simple/Data.js'
export function useOnClick(props) {
  let change = useDataChange({
    context: 'event_action',
    viewPath: props.viewPath,
  })
  return function onClick() {
    change(next => {
      next.data.create_task = true
      next.data.create_task_new = false
    })
  }
}
